var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1444.562,
    height: 1171.837,
    viewBox: "0 0 1444.562 1171.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Split_payment",
    "data-name": "Split payment",
    transform: "translate(-1997.72 -1707.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registration_request",
    "data-name": "Registration request",
    transform: "translate(-2705.41 -6493.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(127 44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(4514.078 8079.961)",
    fill: "#c2b59c",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(-55.199 -138.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M-17910.553,5795.6h0c-2.828-12.519-6.289-25.23-10.283-37.782-6.389-20.061-19.658-40.171-33.705-61.462l-.016-.022c-9.43-14.292-19.18-29.069-27.713-45.03a242.427,242.427,0,0,1-11.643-24.839,185.49,185.49,0,0,1-8.465-26.837,17.053,17.053,0,0,1,.484-9.086,34.2,34.2,0,0,1,4.709-9.186c4.238-6.152,10.5-12.5,16.555-18.64l.016-.015.008-.008c6.27-6.355,12.752-12.927,17.234-19.473,5.041-7.362,6.908-13.837,5.705-19.8a57.986,57.986,0,0,0-8.348-21.045l356.145-86.389,22.275,91.817a1085.913,1085.913,0,0,1,14.449,114.333q.082,1.262.164,2.529c.777,11.829,1.582,24.062,1.846,36.824.035,1.794.107,3.719.174,5.418v.023c.2,5.131.4,10.437-.184,14.7a21.452,21.452,0,0,1-2.7,7.478,15.953,15.953,0,0,1-5.547,5.3c-4.686,2.809-10.746,5.175-16.605,7.463l-.9.353c-3.23,1.236-6.408,2.577-9.484,3.874l-.029.012c-3.059,1.29-6.223,2.624-9.455,3.864-12.361,5.154-24.7,9.9-39.416,15.442-21.068,8.114-41.879,15.943-61.852,23.268l-193.42,46.917h0Zm166.844-239.892c-9.387,0-17.643,2.869-23.877,8.295-.086.076-.176.158-.264.24a54.472,54.472,0,0,0-24.652,28.219c-.627,1.357-1.2,2.77-1.717,4.2-8.4,23.427,2.416,49.806,26.313,64.147a49.312,49.312,0,0,0,25.617,7.372c12.979,0,25.895-5.425,36.369-15.277a50.866,50.866,0,0,0,21.893,5.032c16.836,0,33.795-8.917,45.363-23.853,11.779-15.211,16.2-34.4,11.824-51.341,1.344-7.388-4.7-13.767-6.973-16.168l-.006-.006a10.837,10.837,0,0,1-.852-.951c-4.9-7.157-12.66-13.746-21.846-18.552-9.393-4.914-19.693-7.621-29.006-7.621-9.887,0-18.586,3.021-25.154,8.735a5.205,5.205,0,0,0-1.557,2.3,53.985,53.985,0,0,0-12.3,8.791,62.17,62.17,0,0,0-9.553-2.627,52.109,52.109,0,0,0-9.619-.93Zm115.648,171.368v0c5.041-2.1,10.117-4.213,14.885-6.2,6.25-2.825,12.713-5.745,18.9-8.161,2.031-.942,4.09-1.75,6.082-2.533l.021-.008a65.843,65.843,0,0,0,12.369-5.946c3.051-2.11,6.486-4.688,8.639-8.591a33.6,33.6,0,0,0,3.92-12.548,91.988,91.988,0,0,0,.213-16.573c-.09-1.766-.193-3.767-.23-5.711-.684-13.614-1.643-27.07-2.852-40-1.365-15.508-3.152-31.1-5.316-46.337l27.871,114.892a16.629,16.629,0,0,1-1.975,12.655,16.625,16.625,0,0,1-10.346,7.553Zm18.184-311.121,0-.007c-.74-1.9-18.285-47.078-34.889-96.541-74.295,7.907-207.072,35.945-394.645,83.335a137.063,137.063,0,0,1,4.236-19.1c1.838-6.373,4.018-12.8,6.125-19.015,4.854-14.323,9.873-29.134,11.3-44.514,111-27.345,204.811-57.27,263.961-77.558l70.828-17.18a10.952,10.952,0,0,1,1.365,1.336c3.35,4.031,5.051,10.711,6.7,17.171.334,1.313.75,2.947,1.158,4.433.914,3.323,1.752,6.572,2.49,9.439l.031.119c1.027,3.973,2,7.726,3.053,11.331,7.055,26.415,10.891,38.239,11.561,38.239h.014c.615-.582-1.9-14.475-7.266-40.176-1.064-5.893-2.475-12.079-3.969-18.627-.182-.805-.377-1.663-.57-2.522-.557-2.048-.994-3.982-1.459-6.03l-.02-.08-.016-.071c-.426-1.885-.867-3.834-1.422-5.946a40.974,40.974,0,0,0-4.162-10.429l1.625-.394a16.8,16.8,0,0,1,3.959-.476,16.8,16.8,0,0,1,10.252,3.524,16.644,16.644,0,0,1,3.73,4.038,16.664,16.664,0,0,1,2.262,5.227l43.779,180.478Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 21610.672, 754.655)",
    fill: "#c2b59c",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M-18567.227,5956.572a16.807,16.807,0,0,1-10.256-3.526,16.614,16.614,0,0,1-3.73-4.039,16.653,16.653,0,0,1-2.264-5.229l-7.221-29.759a967.428,967.428,0,0,0-17.25-118c-5.068-24.682-11.178-49.49-18.152-73.734-7.092-24.642-13.336-42.655-17.324-53.426l387.553-94,23.078,23.984-38.928,80.6,87.893,171.9,1.293,12.405-380.734,92.354A16.779,16.779,0,0,1-18567.227,5956.572Zm-54.863-171.972-28.611-117.956-.025-.1.027.1h0l.029.113c.02.076.037.151.057.227l.83,3.422.033-.009c.959,3.776,2.031,7.944,3.164,12.356l.338,1.31c6.559,25.509,15.541,60.445,24.162,100.537Zm-31.572-130.155-39.912-164.542a16.622,16.622,0,0,1,1.975-12.654,16.645,16.645,0,0,1,10.348-7.556l97.5-23.65c38.811-5.535,80.295-12.473,123.3-20.624,48.5-9.191,97.736-19.71,146.355-31.266a409.985,409.985,0,0,1,3.492,76.544c-97.646,24.671-191.389,49.915-252.832,66.748-66.479,18.212-110.664,30.814-111.092,30.937l20.8,85.741.039.175.008.033c0,.019.008.039.012.058s.008.039.014.058Z",
    transform: "translate(18104.715 -8767.614) rotate(-19)",
    fill: "#c2b59c",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M315.622,36.907c-90.184,3.562-171.222.022-230.011-5.85q-22.149-2.041-39.536-4.314c-11.327-1.528-21.4-.206-29.155,3.916A28.283,28.283,0,0,0,7.5,38.19a26.1,26.1,0,0,0-4.961,8.978c-.86,2.954-1.446,5.478-1.749,7.157A19.987,19.987,0,0,1,.2,56.849a10.712,10.712,0,0,1-.2-2.9A58.372,58.372,0,0,1,.98,46a34.948,34.948,0,0,1,5.009-11.06A33.5,33.5,0,0,1,16.24,25.7c8.04-4.968,18.669-7.565,30.534-6.479,11.611.682,24.8,1.7,39.584,2.232,58.591,2.969,139.658,5.26,229.577,1.711S405.805,33.345,315.622,36.907Z",
    transform: "matrix(0.809, -0.588, 0.588, 0.809, 2174.971, 2487.966)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M641.8,99.364c-.483.026-1.4-14.069-2.307-39.812-.344-6.638-.438-13.7-.757-21.591s-.127-17.049-2.18-22.763c-2.286-6.118-7.576-7.084-13.384-6.358-6.058,1.155-12.358,2.323-19.142,3.517A1479.7,1479.7,0,0,1,393.29,36.907c-82.381,3.562-81.853-10.194.286-13.743S550,10.661,603.75,2.8c6.774-.777,13.316-1.958,19.366-2.7,3.141-.168,6.282-.335,9.389,1.163a16.049,16.049,0,0,1,7.774,9.153A51.611,51.611,0,0,1,642.4,24.453c.146,4.568.068,8.316.223,12.468.077,7.9.171,14.967.032,21.63-.064,26.211-.359,40.371-.851,40.813Z",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 2606.494, 2180.087)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M1424.119,297.216c51.372,15.161,99.134,26.8,99.134,26.8L1395.746,669.7l-94.14,16.22-29.849-31.484S1380.984,375.276,1424.119,297.216Z",
    transform: "translate(2984.643 855.942) rotate(68)",
    fill: "#998b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M1379.147,690.179l-144.115,370.614-97.772-38.249,126.629-348.636,34.224,31.216Z",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 1945.395, 1079.993)",
    fill: "#998b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M12.913,31.465c121.327,12.4,245.656,8.666,367.538,11.112-1.057,1.965,15.543-22.645-16.73-33.335C247.157,5.467,128.791-3.886,12.27,1.776-4.848,2.635-3.518,29.792,12.913,31.465Z",
    transform: "translate(2280.824 2612.538) rotate(-34)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M380.451,42.577c115.792,2.359,236.475,19.777,351.794,9.995,20.121-1.715,18.106-31.875-.772-34.492C611.906,1.52,484.488,13.19,363.72,9.242,370.4,21.153,369.55,44.745,380.451,42.577Z",
    transform: "translate(2495.018 2314.038) rotate(-1)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M.952,320.8c-3.573-.288,4.022-72.111,4.616-160.739C6.148,71.85-.612.958,2.64.009,5.535-.927,17.674,69.772,17.054,159.233,16.794,248.681,3.807,321.114.951,320.8Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 2314.057, 2652.324)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M139.437,301.226c-43.309-.939-78.359-2.591-102.305-4.227C13.2,294.948-.376,293.772.008,292.926c.026-.833,13.651-1.323,37.637-.937,24.357-.043,59.086.372,102.434.062C226.788,291.015,226.068,302.689,139.437,301.226Z",
    transform: "translate(2346.4 2646.928) rotate(-31)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M777.344,0c.358-.013.96,3.709,1.445,11.18s1.226,18.26,1.5,32.393a842.177,842.177,0,0,1-6.221,120.03c-1.462,12.532-3.309,25.911-5.527,39.718-1.282,6.7-1.86,13.795-4.614,21.8a33.729,33.729,0,0,1-6.444,11.463c-2.971,3.435-6.967,5.242-10.233,6.608-7.249,2.757-13.344,2.976-19.837,4.457-6.48,1.065-13.332,2.559-20.183,4.053-13.69,2.572-27.38,5.144-41.787,7.742-57.257,9.962-120.584,19.31-186.7,26.262-132.608,14.334-132.2,1.007.054-13.314,66.118-6.952,129.074-15.871,186.3-25,14.394-2.181,28.071-4.337,41.761-6.909,6.839-1.078,13.332-2.559,20.17-3.637,6.48-1.065,13.319-2.143,18.749-4s8.4-5.294,10.721-10.785c1.96-5.478,2.909-13,4.191-19.7,2.564-13.4,4.4-26.366,6.219-38.911a1093.471,1093.471,0,0,0,9.769-118.909c-.174-29.113-.414-44.5.662-44.535Z",
    transform: "translate(2506.27 2372.212) rotate(5)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M38.4,17.449c10.781-1.4,20.871-2.824,31.628.9A49.607,49.607,0,0,1,96.443,39.953c4.714,12.511,2.984,4.76,4.635,13.592,2.747,20.478-11.034,42.484-30.917,48.861-26.244,8.413-56-11.906-59.236-38.921C8.454,42.837,21.283,26.221,38.4,17.449Zm-7.676,93.28C76.15,137.993,126.49,88.165,114.9,43.3c1.582-8.712-7-15.908-7.833-17.125-14.717-21.487-54.1-36.5-76-17.435a5.1,5.1,0,0,0-1.754,3.133A60.55,60.55,0,0,0,3,43.146C-6.507,69.662,7.607,96.857,30.722,110.729Z",
    transform: "matrix(0.988, 0.156, -0.156, 0.988, 3097.857, 2481.347)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M2177.737,825.315a54.367,54.367,0,1,1-30.827-70.438A54.368,54.368,0,0,1,2177.737,825.315Z",
    transform: "matrix(0.438, 0.899, -0.899, 0.438, 2878.039, 288.016)",
    fill: "#998b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M36.446,16.562c10.233-1.327,19.811-2.681,30.02.852A47.085,47.085,0,0,1,91.54,37.922c4.475,11.875,2.833,4.518,4.4,12.9C98.547,70.261,85.467,91.147,66.594,97.2c-24.91,7.985-53.157-11.3-56.225-36.942C8.024,40.66,20.2,24.888,36.446,16.562ZM29.16,105.1c43.118,25.878,90.9-21.417,79.9-64,1.5-8.269-6.642-15.1-7.434-16.254C87.655,4.447,50.276-9.8,29.483,8.293a4.84,4.84,0,0,0-1.664,2.974A57.469,57.469,0,0,0,2.851,40.953C-6.176,66.121,7.22,91.933,29.16,105.1Z",
    transform: "matrix(0.988, 0.156, -0.156, 0.988, 3040.664, 2488.756)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M535.388,54.861c-.467.017-1.348-9.284-2.227-26.272-.333-4.38-.423-9.043-.73-14.248s-.123-11.25-2.1-15.021c-2.207-4.037-7.314-4.675-12.921-4.2-5.849.762-11.93,1.533-18.479,2.321C470.932,1.129,334.289,36.884,334.289,36.884l-63.95-59.3L165.977,43.238S113.95,11.379,92.642,9.786Q73.11,8.439,57.777,6.939c-9.989-1.008-9.846-5.68.617-4.964C68.633,2.426,80.263,3.1,93.3,3.448c20.409.774,70.388,31.584,70.388,31.584L270.616-31.484,336.136,28.7S470.944-6.089,498.652-8.858c6.54-.513,12.855-1.292,18.7-1.78,3.033-.111,6.065-.221,9.064.768a13.073,13.073,0,0,1,7.505,6.04,24.264,24.264,0,0,1,2.048,9.259c.141,3.014.066,5.488.215,8.227.074,5.213.165,9.876.031,14.273-.062,17.3-.347,26.64-.822,26.932Z",
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 2520.625, 2251.339)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M530.325-.68c-2.207-4.037-7.314-4.675-12.921-4.2-5.849.762-11.93,1.533-18.479,2.321C470.932,1.129,334.289,36.884,334.289,36.884l-63.95-59.3L165.977,43.238S113.95,11.379,92.642,9.786Q73.11,8.439,57.777,6.939c-9.989-1.008-9.846-5.68.617-4.964C68.633,2.426,80.263,3.1,93.3,3.448c20.409.774,70.388,31.584,70.388,31.584L270.616-31.484,336.136,28.7S470.944-6.089,498.652-8.858c6.54-.513,12.855-1.292,18.7-1.78,3.033-.111,6.065-.221,9.064.768a13.073,13.073,0,0,1,7.505,6.04C535.449-.592,532.307,3.091,530.325-.68Z",
    transform: "translate(2875.645 2153.571) rotate(91)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "%",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 2327.359, 2189.158)",
    fill: "#333",
    fontSize: 86,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_50",
    "data-name": 50,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 2203.816, 2258.343)",
    fill: "#333",
    fontSize: 114,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "%",
    transform: "translate(3049.773 2002.935) rotate(-4)",
    fill: "#333",
    fontSize: 86,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_50-2",
    "data-name": 50,
    transform: "translate(2908.77 2015.889) rotate(-4)",
    fill: "#333",
    fontSize: 114,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitPay);
export default __webpack_public_path__ + "static/media/splitPay.98b37c5e1ab47a827ca2e7d66aa63856.svg";
export { ForwardRef as ReactComponent };